var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid text-center text-white"},[_c('brand-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }